export const calculateProgress = (validFields: number, totalFields: number) => {
  return parseFloat((((validFields * 1.0) / totalFields) * 100).toFixed(2));
};
